import * as Yup from "yup";
import {
  CONFIRM_PASSWORD_REQUIRED,
  MIN_CHAR_LENGTH,
  PASSWORD_MUST_MATCH,
  PASSWORD_REQUIRED,
} from "../../constants/messages";
import { PASSWORD_MIN_CHAR } from "../../constants";

export const ResetPasswordSchema = Yup.object({
  password: Yup.string()
    .required(PASSWORD_REQUIRED)
    .min(PASSWORD_MIN_CHAR, MIN_CHAR_LENGTH),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), ""], PASSWORD_MUST_MATCH)
    .required(CONFIRM_PASSWORD_REQUIRED),
});
